module.exports = __webpack_public_path__ + "7137c5ed376de9ded4f30d9306e0d152.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/checkoutWidget/cross-icon.svg
// module id = mpwA
// module chunks = 458